import _regeneratorRuntime from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { setAssetsLoaded, setStockControl } from '../../state/slices/assetsPackage/assetsPackage';
import store from '../../state/store';

var imagePreload = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(images, assetsPackage) {
    var items, assetsPackageId, lastAssetsPackageId, lastRevisionNumber, imageObject, _imagePreload, i;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            items = assetsPackage.items, assetsPackageId = assetsPackage.assetsPackageId;
            lastAssetsPackageId = store.getState().assetsPackage.assetsPackageId;
            lastRevisionNumber = Object.values(store.getState().assetsPackage.lastRevisionNumber);
            imageObject = Object.values(images);
            if (lastAssetsPackageId !== assetsPackageId) handlePreload(imageObject);else {
              _imagePreload = [];

              for (i = 0; i < imageObject.length; i++) {
                if (imageObject[i].substr(-1) != lastRevisionNumber[i]) _imagePreload.push(imageObject[i]);
              }

              _imagePreload.length > 0 && handlePreload(_imagePreload);
            }
            store.dispatch(setAssetsLoaded(true));
            store.dispatch(setStockControl({
              assetsPackageId: assetsPackageId,
              lastRevisionNumber: Object.values(items)
            }));

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function imagePreload(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

var handlePreload = function handlePreload(images) {
  images.forEach(function (img) {
    var cachedFile = new Image();
    return new Promise(function (resolve) {
      cachedFile.onload = function () {
        resolve('loaded');
      };

      cachedFile.onerror = function () {
        resolve('error');
      };

      cachedFile.src = img;
    });
  });
};

export default imagePreload;